module.exports = __webpack_public_path__ + "img/linha-mestre-icon.80ab7a28.png";